export default {
  switchLang(state, payload) {
    state.lang = payload;
  },
};
